module.exports = __webpack_public_path__ + "img/top-login-button.b68650bb.png";